import React from 'react';
import PropTypes from 'prop-types';

import {IconoirWarningTriangle} from '@ey-xd/motif-icon';
import Icon from '@ey/canvascoreservices/Icon';

import MessageWithTrigger from '../MessageWithTrigger';
import StyledAccountAndRiskDetailsFooterMessage from './StyledAccountAndRiskDetailsFooterMessage';

const AccountAndRiskDetailsFooterMessage = ({
	message,
	renderTrigger = null,
	icon = IconoirWarningTriangle,
	color = 'orange'
}) => {
	const props = {
		message
	};

	if (renderTrigger) props.renderTrigger = renderTrigger;

	return (
		<StyledAccountAndRiskDetailsFooterMessage>
			{icon && <Icon src={icon} className={color} />}
			<MessageWithTrigger {...props} />
		</StyledAccountAndRiskDetailsFooterMessage>
	);
};

AccountAndRiskDetailsFooterMessage.propTypes = {
	message: PropTypes.string,
	renderTrigger: PropTypes.func,
	icon: PropTypes.any,
	color: PropTypes.oneOf(['orange', 'blue'])
};

export default AccountAndRiskDetailsFooterMessage;
